import { PathOptions } from "leaflet";

export const portos = (feature: any): PathOptions => {
  return {
    color: "#1e5a8e",
    weight: 2,
    fillColor: "#4a90d9",
    fillOpacity: 0.7,
  };
};
